/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import UsersList from "../../Modals/usersList";
import React from "react";

const NotificationsList = () => {

  const usersList = [
    { id: "1", label: "John Doe", avatar: "/static/images/user_placeholder.png" },
    { id: "2", label: "Jane Smith", avatar: "/static/images/user_placeholder.png" },
    { id: "3", label: "Michael Scott", avatar: "/static/images/user_placeholder.png" },
    { id: "4", label: "Pam Beesly", avatar: "/static/images/user_placeholder.png" },
  ];

  const rows = [
    {
      id: 1,
      title: "Lorem Ipsum",
      message: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, aliquam.",
      type: "Broadcast",
      date: "01 March 2025",
      users: ["1", "2", "3", "4"]
    },
    {
      id: 2,
      title: "Lorem Ipsum",
      message: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, aliquam.",
      type: "Email",
      date: "01 March 2025",
      users: ["2", "3"]
    },
  ];

  const getUserLabel = (userIds: string[]) => {
    if (userIds.length === usersList.length) return "All Users";
    return `${userIds.length} Users`;
  };

  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Users</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.message}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell className="click_action" onClick={() => {setSelectedUserIds(row.users); setOpenUserModal(true);}}>{getUserLabel(row.users)}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>
                  <Box className="table_actions v2">
                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="delete" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationsList;
